var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6963 8.35809H9.6427V5.30451C9.6427 5.21612 9.57038 5.1438 9.48199 5.1438H8.5177C8.42931 5.1438 8.35699 5.21612 8.35699 5.30451V8.35809H5.30341C5.21502 8.35809 5.1427 8.43041 5.1427 8.5188V9.48309C5.1427 9.57148 5.21502 9.6438 5.30341 9.6438H8.35699V12.6974C8.35699 12.7858 8.42931 12.8581 8.5177 12.8581H9.48199C9.57038 12.8581 9.6427 12.7858 9.6427 12.6974V9.6438H12.6963C12.7847 9.6438 12.857 9.57148 12.857 9.48309V8.5188C12.857 8.43041 12.7847 8.35809 12.6963 8.35809Z",
    fill: "#1890FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.02991 0 0 4.02991 0 9C0 13.9701 4.02991 18 9 18C13.9701 18 18 13.9701 18 9C18 4.02991 13.9701 0 9 0ZM9 16.4732C4.87366 16.4732 1.52679 13.1263 1.52679 9C1.52679 4.87366 4.87366 1.52679 9 1.52679C13.1263 1.52679 16.4732 4.87366 16.4732 9C16.4732 13.1263 13.1263 16.4732 9 16.4732Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.8f9673519536a2212370df46964c799e.svg";
export { ForwardRef as ReactComponent };